import { httpRequest } from "@services/http";
import { ConsumerJourney } from "@models/population.model";

export class CommandGetConsumerJourney {
  async run(launchId: number, consumerId: number): Promise<ConsumerJourney> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/population/consumers/${consumerId}/`;
    return await httpRequest<ConsumerJourney>(url, { method: "GET", cache: "no-store" });
  }
}
